// AI Citator (case treatment badge + panel) analytics enumerations.

import { CaseStatusEnum, type DisplayableCaseStatus } from '@/citator/schema/case-status-schema'
import { CaseReviewEnum, type DisplayableCaseReview } from '@/citator/schema/case-review-schema'

export enum CitatorBadgeType {
  NoFlagsDetected = 'no_flags_detected',
  UseCaution = 'use_caution',
  NegativeTreatment = 'negative_treatment',
}

// `drafting` is reserved for the artifact-editor surface (no call sites yet).
export enum CitatorSurface {
  Chat = 'chat',
  Drafting = 'drafting',
}

export enum CitatorPanelSource {
  BadgeClick = 'badge_click',
  CitationClick = 'citation_click',
}

// Mirrors backend `CaseReviewEnum` 1:1; the emitted value is the backend key (not
// the UI label) to keep a stable analytics join key, decoupled from display copy.
export enum CitatorTreatmentOutcome {
  Overturned = 'overturned',
  OverturnedInPart = 'overturned_in_part',
  Vacated = 'vacated',
  OverturningRecognized = 'overturning_recognized',
  Refined = 'refined',
  Distinguished = 'distinguished',
  Questioned = 'questioned',
}

export function mapCaseStatusToBadgeType(status: DisplayableCaseStatus): CitatorBadgeType {
  switch (status) {
    case CaseStatusEnum.likely_good:
      return CitatorBadgeType.NoFlagsDetected
    case CaseStatusEnum.likely_bad:
      return CitatorBadgeType.NegativeTreatment
    case CaseStatusEnum.caution:
      return CitatorBadgeType.UseCaution
  }
}

export function mapCaseReviewToTreatmentOutcome(review: DisplayableCaseReview): CitatorTreatmentOutcome {
  switch (review) {
    case CaseReviewEnum.overturned:
      return CitatorTreatmentOutcome.Overturned
    case CaseReviewEnum.overturned_in_part:
      return CitatorTreatmentOutcome.OverturnedInPart
    case CaseReviewEnum.vacated:
      return CitatorTreatmentOutcome.Vacated
    case CaseReviewEnum.overturning_recognized:
      return CitatorTreatmentOutcome.OverturningRecognized
    case CaseReviewEnum.refined:
      return CitatorTreatmentOutcome.Refined
    case CaseReviewEnum.distinguished:
      return CitatorTreatmentOutcome.Distinguished
    case CaseReviewEnum.questioned:
      return CitatorTreatmentOutcome.Questioned
  }
}
